import type { ProjectId } from "features/shared/model/types";
import type { QueryClient } from "react-query";

import type { AllCacheKeys } from "./cacheKeys";

export const invalidateConfigGroupQueries = (
  queryClient: QueryClient,
  cacheKeys: AllCacheKeys,
  projectId: ProjectId,
  recordId?: string
) => {
  queryClient.invalidateQueries(cacheKeys.groups(projectId));
  queryClient.invalidateQueries(cacheKeys.catalog);
  if (recordId) {
    queryClient.invalidateQueries(cacheKeys.detail(projectId, recordId));
  }
};
